<template>
  <div class="row justify-between items-center content-center full-width">
    <div class="col-3">
      <q-btn
        flat
        dense
        label="Previous"
        padding="none"
        color="secondary"
        :class="localValue === 0 ? ' invisible' : ''"
        size="12px"
        @click="previous"
      />
    </div>
    <div class="text-caption text-center">
      {{ localValue + 1 }} / {{ length }}
    </div>
    <div class="col-3 text-right">
      <q-btn
        flat
        dense
        label="Next"
        padding="none"
        color="secondary"
        :class="(localValue === length - 1 ? ' invisible' : '')"
        size="12px"
        @click="next"
      />
    </div>
  </div>
</template>

<script>
import mixin from "./d-card-mixins";
export default {
  name: "DCardToolbarNavigation",
  mixins: [mixin],
  props: {
    length: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    next() {
      if (this.length <= 0 || this.localValue === this.length - 1) return;
      this.localValue++;
    },
    previous() {
      if (this.length <= 0 || this.localValue === 0) return;
      this.localValue--;
    }
  }
};
</script>
<style lang="scss" scoped>
@import url('./d-card.scss');
</style>
